import React from 'react';
import { motion } from 'framer-motion';
import { BrainCircuitIcon, ZapIcon, CheckCircle2Icon } from 'lucide-react';
const STEPS = [{
  num: '01',
  icon: BrainCircuitIcon,
  title: 'Aprendés el Sistema',
  desc: 'Dominás el método exacto para pedirle a la IA lo que necesitás, cuando lo necesitás.'
}, {
  num: '02',
  icon: ZapIcon,
  title: 'Aplicás los Prompts',
  desc: 'Usás nuestro sistema de prompts diseñado pedagógicamente para docentes argentinos.'
}, {
  num: '03',
  icon: CheckCircle2Icon,
  title: 'Creás tu Material',
  desc: 'Generás planificaciones, actividades y evaluaciones en 10 minutos. Sin volver a depender de nadie.'
}];
export function SolutionSection() {
  return <section className="pt-0 pb-14 bg-zinc-950 relative" data-id="element-275">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[300px] bg-yellow-500/5 blur-[100px] rounded-full pointer-events-none" data-id="element-276" />

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-277">
        <div className="text-center mb-10" data-id="element-278">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-4xl font-black uppercase tracking-tight text-white mb-3" data-id="element-279">
            La Solución Definitiva
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-280">
            No compres más material de otros. Aprendé a crear el tuyo. Para
            siempre.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-281">
          {STEPS.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 relative overflow-hidden group hover:border-yellow-500/50 transition-colors" data-id="element-282">
              <div className="absolute -right-4 -top-4 text-8xl font-black text-zinc-800/50 group-hover:text-yellow-500/10 transition-colors" data-id="element-283">
                {step.num}
              </div>

              <div className="relative z-10" data-id="element-284">
                <div className="w-12 h-12 rounded-xl bg-yellow-500/10 flex items-center justify-center mb-4 border border-yellow-500/20" data-id="element-285">
                  <step.icon className="w-6 h-6 text-yellow-500" data-id="element-286" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-287">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-400 leading-relaxed" data-id="element-288">
                  {step.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}